import styled from "styled-components";

interface StyledDialogHeaderProps {
  $size: "large" | "medium" | "small";
}

export const StyledDialogHeader = styled.header<StyledDialogHeaderProps>`
  box-sizing: border-box;
  width: 100%;
  padding: 0.4rem 0.4rem 0.4rem 1.6rem;
  border-bottom: 1px solid var(--bg-gray-1);
  display: flex;
  gap: 0.4rem;
  align-items: center;
  & > p {
    font: var(--label-medium-400);
    color: var(--text-gray-strong);
    flex: 1;
    height: ${({ $size }) => ($size === "large" ? "4rem" : "2.8rem")};
    line-height: ${({ $size }) => ($size === "large" ? "4rem" : "2.8rem")};
  }
`;
